import {
  I18N_SUBMIT_CONFIRMATION_BUTTON_KEY,
  I18N_SUBMIT_DISCLAIMER_KEY,
  I18N_WARNINGS_CHECK_LABEL_KEY
} from 'lf-at-theme';

/**
 * App i18n object for the en-US locale.
 */

export const appI18NEnUS: Record<string, any> = {
  '*': {
    saveFileName: 'oss-intermediary-registration',
    [I18N_SUBMIT_DISCLAIMER_KEY]: 'You are about to submit a Import Scheme registration as an Intermediary. Do you wish to continue?',
    [I18N_SUBMIT_CONFIRMATION_BUTTON_KEY]: 'Submit',
    [I18N_WARNINGS_CHECK_LABEL_KEY]: 'I declare that I am aware of the warnings generated by the data of this declaration.',
    ["modalYesBtn"]: 'Confirm',
    ["modalNoBtn"]: 'Cancel',
    ["schemeConditionsTitle"]: 'Admission Conditions',
    ["schemeConditions"]: `
      <p>To register in this scheme you should:</p>
      <ul>
        <li>Be a taxable person established in the Portuguese territory.</li>
        <li>Intend to Act in the name and on behalf of other taxable person.</li>
        <li>Comply with all obligations of the regime on behalf of the one´s you will represent.</li>
      </ul>
    `,
  }
};
